import styles from "../../styles/add2.module.scss";

import { Icon } from "./core/Icon";

export const Add2 = ({ text, onClick, className = "", style = {} }) => {
  return (
    <div
      className={`${styles.addContainer} ${className}`}
      onClick={onClick}
      style={style}
    >
      <div className={styles.icon}>
        <Icon name="plus" size="1x" />
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  );
};
